import * as firebase from "firebase";
import "firebase/firestore";

let config = {
  apiKey: "AIzaSyCf4fwOzmZcAdFjcN8JaRxAm8XJXF8pSzQ",
  authDomain: "learner-ms.firebaseapp.com",
  projectId: "learner-ms",
  storageBucket: "learner-ms.appspot.com",
  messagingSenderId: "644824883591",
  appId: "1:644824883591:web:ab02c9c1c8b00712d83322"
  
};

firebase.initializeApp(config);

export default firebase;